import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";

import MyAccountLayout from "./MyAccountLayout";
import CustomDatePicker from "../../components/CustomDatePicker";
import MyAccountFilter from "./MyAccountFilter";
import Pagination from "../../components/Pagination";
import { apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import { formatDate, toFixedWithoutRounding } from "../../Utils/Constant";

const AWCcasinoBetHistory = () => {
  const params = useParams();
  const tableRef = useRef();

  const DEFAULT_FILTER = {
    page: 1,
    limit: 10,
    type: "3",
    betType: "casino",
    sortOrder: "asc",
    casionType: -1, // AWC specifically, same lookup value CasinoListing.jsx uses for "awc"
    userType: params?.type,
    id: params?.id,
    fromPeriod: moment().subtract(1, "day").format("YYYY-MM-DD HH:mm:ss"),
    toPeriod: moment().format("YYYY-MM-DD HH:mm:ss"),
  };

  const [filter, setFilter] = useState(DEFAULT_FILTER);
  const [data, setData] = useState({});

  const getData = async (activeFilter) => {
    const { status, data: response_users } = await apiGet(
      apiPath.getCasinoNew,
      activeFilter,
    );
    if (status === 200 && response_users.success) {
      setData(response_users.results || {});
    }
  };

  useEffect(() => {
    getData(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.page, filter.limit, filter.id, filter.userType]);

  useEffect(() => {
    setFilter((prev) =>
      prev.id === params?.id && prev.userType === params?.type
        ? prev
        : { ...prev, page: 1, userType: params?.type, id: params?.id },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.id, params?.type]);

  const applyPreset = (preset) => {
    const fromPeriod =
      preset === "today"
        ? moment().startOf("day")
        : moment().subtract(1, "day").startOf("day");
    const toPeriod =
      preset === "today"
        ? moment().endOf("day")
        : moment().subtract(1, "day").endOf("day");
    const nextFilter = {
      ...filter,
      page: 1,
      fromPeriod: fromPeriod.format("YYYY-MM-DD HH:mm:ss"),
      toPeriod: toPeriod.format("YYYY-MM-DD HH:mm:ss"),
    };
    setFilter(nextFilter);
    if (filter.page === nextFilter.page) getData(nextFilter);
  };

  const handleLimitChange = (e) =>
    setFilter((prev) => ({ ...prev, limit: Number(e.target.value), page: 1 }));
  const handlePageChange = (newPage) =>
    setFilter((prev) => ({ ...prev, page: newPage }));

  const rows = data?.data || [];
  const totalPL = rows.reduce(
    (sum, item) => sum + Number(item?.playerPL),
    0,
  );

  return (
    <MyAccountLayout>
      <div id="report" className="col-center report">
        <app-parlaybethistory className="ng-star-inserted">
          <div
            className="box ng-star-inserted"
            style={{ alignItems: "baseline" }}
          >
            <h3
              style={{
                fontSize: "24px",
                marginTop: "20px",
                marginBottom: "10px",
              }}
              className="ng-star-inserted"
            >
              AWC Casino Betting History
            </h3>
          </div>

          <div className="function-wrap">
            <ul className="input-list">
              <li>
                <label>Period</label>
              </li>
              <CustomDatePicker filter={filter} setFilter={setFilter} />
            </ul>
            <ul className="input-list flowroot">
              <li>
                <a
                  id="today"
                  className="btn"
                  onClick={(e) => {
                    e.preventDefault();
                    applyPreset("today");
                  }}
                >
                  Just for today
                </a>
              </li>
              <li>
                <a
                  id="yesterday"
                  className="btn"
                  onClick={(e) => {
                    e.preventDefault();
                    applyPreset("yesterday");
                  }}
                >
                  From yesterday
                </a>
              </li>
              <li>
                <a
                  id="getPL"
                  className="btn-send"
                  onClick={(e) => {
                    e.preventDefault();
                    getData(filter);
                  }}
                >
                  Get P &amp; L
                </a>
              </li>
            </ul>
          </div>
          <div id="userTreeDiv" className="total_all">
            <div style={{ fontWeight: "bold" }}>
              {" "}
              Total P/L:&nbsp;
              <span className={totalPL < 0 ? "red" : "green"}>
                {toFixedWithoutRounding(totalPL)}
              </span>
            </div>
            <span className="spacer" />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>
                <label>Last:</label>
                <select
                  name="limit"
                  id="limit"
                  value={filter.limit}
                  onChange={handleLimitChange}
                >
                  <option value={10}>10 Txn</option>{" "}
                  <option value={25}>25 Txn</option>{" "}
                  <option value={50}>50 Txn</option>
                  <option value={100}>100 Txn</option>
                </select>
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <MyAccountFilter
                type="new"
                tableRef={tableRef}
                fileName="activity-log"
              />
            </div>
          </div>
          <div id="report">
            <div
              className="table-responsive data-table"
              style={{ overflow: "auto", whiteSpace: "nowrap" }}
            >
              <table
                id="table_DL"
                ref={tableRef}
                className="table-s"
                style={{ display: "table" }}
              >
                <tbody>
                  <tr>
                    <th width="10%" className="align-L sort_asc">
                      {" "}
                      Bet ID
                    </th>
                    <th width="8%" className="align-L sort_asc">
                      {" "}
                      Event
                    </th>
                    <th width="8%" className="align-L sort_asc">
                      {" "}
                      Bet Placed
                    </th>
                    <th width="8%" className="align-L sort_asc">
                      {" "}
                      Bet Settled
                    </th>
                    <th width="8%" className="sort_asc">
                      {" "}
                      Stake
                    </th>
                    <th width="10%" className="sort_asc">
                      {" "}
                      Profit/Loss
                    </th>
                  </tr>

                  {rows.length > 0 ? (
                    rows.map((item, index) => {
                      const pl = Number(item?.playerPL);
                      return (
                        <tr
                          key={item?._id || index}
                          style={{ display: "table-row" }}
                        >
                          <td className="align-L"> {item?.casinoBetId}</td>
                          <td className="align-L">
                            {" "}
                            {item?.platform} - {item?.gameCode} -{" "}
                            {item?.casinoName}
                          </td>
                          <td className="align-L">
                            {" "}
                            {formatDate(item?.timeInserted)}
                          </td>
                          <td className="align-L">
                            {" "}
                            {item?.updatedAt
                              ? formatDate(item?.updatedAt)
                              : "-"}
                          </td>
                          <td>
                            {toFixedWithoutRounding(item?.betAmount || 0)}
                          </td>
                          <td className={pl < 0 ? "red" : "green"}>
                            {" "}
                            {toFixedWithoutRounding(pl)}{" "}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={6}>You have no bets in this time period.</td>
                    </tr>
                  )}
                </tbody>
              </table>

              {rows.length > 0 && data?.totalDocs > 0 && (
                <Pagination pagination={data} onPageChange={handlePageChange} />
              )}
            </div>
          </div>
        </app-parlaybethistory>
      </div>
    </MyAccountLayout>
  );
};

export default AWCcasinoBetHistory;
